import React, { useEffect, useState } from "react";
import {
  FaFacebookF,
  FaWhatsapp,
  FaLinkedinIn,
  FaInstagram,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { FiLoader } from "react-icons/fi";
import { assets } from "../../Assets/assets";
import CommonButton from "./CommonButton";
import { Link, useNavigate } from "react-router-dom";
import axios from "../../Utils/axiosInstance";
import { generatePriceQuotationPdf } from "../../Utils/Pdf/generatePriceQuotationPdf";

const UserFooter = () => {
  const navigate = useNavigate();
  const [quotations, setQuotations] = useState([]);
  const [hasQuotations, setHasQuotations] = useState(false);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    fetchQuotations();
  }, []);

  const fetchQuotations = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/price-quotation`,
        { params: { paginate: "false" } }
      );
      const data = res.data?.data.quotations || [];
      setQuotations(data);
      setHasQuotations(data.length > 0);
    } catch (err) {
      console.error("Failed to fetch quotations");
    }
  };

  // Convert image URL → base64 so jsPDF can embed it
  const getLogoBase64 = () =>
    new Promise((resolve) => {
      try {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          canvas.getContext("2d").drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        };
        img.onerror = () => resolve(null);
        // Use pcmlogo if available, fall back to footerLogo
        img.src = assets.pcmlogo || assets.footerLogo;
      } catch {
        resolve(null);
      }
    });

  const handleDownloadPdf = async () => {
    if (!hasQuotations) return;
    try {
      setDownloading(true);

      // If we don't have all records yet, re-fetch without pagination
      let allQuotations = quotations;
      if (quotations.length === 0) {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/price-quotation`,
          { params: { paginate: "false" } }
        );
        allQuotations = res.data?.data.quotations || [];
      }

      const logoBase64 = await getLogoBase64();
      generatePriceQuotationPdf(allQuotations, logoBase64);
    } catch (err) {
      console.error("PDF generation failed", err);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div
      className="relative h-auto pt-20 md:pt-40 pb-16 md:pb-0 text-white flex items-end justify-center bg-cover bg-top bg-no-repeat"
      style={{ backgroundImage: `url(${assets.footerbanner})` }}
    >
      {/* BLACK OVERLAY */}
      <div className="absolute inset-0 bg-black/70" />
      <div className="relative w-full z-10 2xl:px-0 px-6 xl:px-8 bottom-0 2xl:max-w-7xl">

        {/* TOP SECTION */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">

          {/* LEFT */}
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <img src={assets.qqtdark} alt="QQT Logo" className="w-28 mb-4" />
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              Quick Quotations & Trade (QQT) is an online live bulk trade platform of PCM Exports (India) for Agro Commodities & Processed Food products (domestic) & Chemical-based products (Exports).
            </p>

            {/* ADDRESS SECTION */}
            {/* <div className="mt-4 w-full">
              <div className="">
                <h3 className="flex items-center gap-2 text-sm md:text-base font-semibold text-white mb-2">
                  <FaMapMarkerAlt className="text-subPrimaryColor" />
                  Our Office Location
                </h3>
                <p className="text-xs md:text-sm text-gray-300 leading-relaxed">
                  Block-A, Bharati Tower, Forestpark <br />
                  Ekamra Marg, Bhimpur <br />
                  Bhubaneswar, Khordha, Odisha - 751009
                </p>
              </div>
            </div> */}
          </div>

          {/* CENTER LINKS */}
          <div className="flex flex-wrap items-center gap-3 text-sm text-gray-300 justify-center max-w-full">
            <Link to="/privacy-policy" className="border-r border-gray-400 pr-4 md:pr-6 last:border-none last:pr-0 hover:underline whitespace-nowrap">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions" className="border-r border-gray-400 pr-4 md:pr-6 last:border-none last:pr-0 hover:underline whitespace-nowrap">
              Terms & Conditions
            </Link>
            <Link to="/refund-policy" className="border-r border-gray-400 pr-4 md:pr-6 last:border-none last:pr-0 hover:underline whitespace-nowrap">
              Refund Policy
            </Link>
            <Link to="/career" className="pr-4 md:pr-6 last:pr-0 hover:underline whitespace-nowrap">
              Career
            </Link>
          </div>

          <div className="flex flex-col items-start md:items-end justify-end gap-4 w-full md:w-auto">
            {/* DOWNLOAD CARD */}
            <div className="bg-[#ffffff1c] backdrop-blur-sm rounded-2xl p-4 flex items-center gap-4 w-fit shadow-sm">

              {/* PLAY STORE */}
              <div className="flex flex-col items-start">
                <a href="https://play.google.com/store/apps/details?id=com.pcmexports" target="_blank" rel="noopener noreferrer">
                  <img
                    src={assets.playstore}
                    alt="playstore"
                    className="w-36 mb-2"
                  />
                </a>
                <p className="text-xs text-gray-200">Scan To Download</p>
              </div>

              {/* QR */}
              <img
                src={assets.qr}
                alt="qr"
                className="w-20 h-20 object-contain"
              />
            </div>
            {/* RIGHT BUTTON */}
            <div className="flex flex-col sm:flex-row justify-start gap-3 md:justify-end items-start sm:items-center w-full">
              {hasQuotations ? (
                <button
                  onClick={handleDownloadPdf}
                  disabled={downloading}
                  className="flex items-center gap-2 px-4 py-2 bg-primaryBtnColor hover:bg-primaryBtnHoverColor text-white rounded-lg text-sm font-semibold hover:opacity-90 transition disabled:opacity-60 disabled:cursor-not-allowed min-w-[12rem] justify-center"
                >
                  {downloading ? (
                    <>
                      <FiLoader className="animate-spin" size={14} />
                      Generating...
                    </>
                  ) : (
                    "Download Price Quotation"
                  )}
                </button>
              ) : (
                <span className="opacity-50 cursor-not-allowed text-sm">
                  Price Quotation not available
                </span>
              )}
              <CommonButton className="min-w-[10rem] w-full sm:w-auto" onClick={() => navigate("/contact-us")} label="Contact Us" />
            </div>
            {/* RIGHT SOCIAL */}
            <div className="flex items-center gap-4">
              <span className="text-gray-300">Follow:</span>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full border border-gray-400 hover:bg-white hover:text-black transition">
                  <FaFacebookF />
                </div>
                <div className="w-8 h-8 flex items-center justify-center rounded-full border border-gray-400 hover:bg-white hover:text-black transition">
                  <FaWhatsapp />
                </div>
                <div className="w-8 h-8 flex items-center justify-center rounded-full border border-gray-400 hover:bg-white hover:text-black transition">
                  <FaLinkedinIn />
                </div>
                <div className="w-8 h-8 flex items-center justify-center rounded-full border border-gray-400 hover:bg-white hover:text-black transition">
                  <FaInstagram />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* DIVIDER */}
        <div className="border-t border-gray-500 mt-6" />

        {/* BOTTOM SECTION */}
        <div className="flex flex-col md:flex-row items-center py-4 justify-between gap-4 text-sm text-gray-300">

          {/* LEFT */}
          <div className="text-center md:text-left flex items-center gap-2">
            <img src={assets.pcmlogo} alt="PCM Logo" className="w-10" />
            All rights reserved ©Copyright {new Date().getFullYear()}{" "}
            <span className="text-subPrimaryColor font-medium">PCM Exports</span>
          </div>
          {/* RIGHT */}
          <div className="text-center md:text-right">
            Developed by{" "}
            <Link to="https://www.webbocket.com" target="_blank" className="text-subPrimaryColor hover:underline">
              WebBocket Software pvt. ltd.
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
};

export default UserFooter;